.c-finished-icon {
  background: url('../../../assets/subscription_success.png') no-repeat;
  background-size: 100%;
  height: 140px;
  width: 140px;
  margin: auto;
}

.c-finished {
  display: inline;
  text-align: center;
  font-weight: 600;
  h2 {
    font-size: 26px;
    color: #000;
  }
}

.c-invitation-completed {
  max-width: 829px;
  text-align: center;

  .btn-toolbar {
    text-align: center;
    .btn {
      float: none;
    }
  }
}



// WEBPACK FOOTER //
// webpack:///sef/pro/assets/routes/Invite/components/InviteBoarding.less